export const point = (x: number, y: number) => ({ x, y });

export const multiply = (point1, point2) => {
  if (typeof point2 === "number") {
    return point(point1.x * point2, point1.y * point2);
  }
  return point(point1.x * point2.x, point1.y * point2.y);
};

export const divide = (point1, point2) => {
  if (typeof point2 === "number") {
    return point2 !== 0
      ? point(point1.x / point2, point1.y / point2)
      : point(0, 0);
  }
  return point(
    point2.x !== 0 ? point1.x / point2.x : 0,
    point2.y !== 0 ? point1.y / point2.y : 0
  );
};

export const add = (point1, point2) => {
  if (typeof point2 === "number") {
    return point(point1.x + point2, point1.y + point2);
  }
  return point(point1.x + point2.x, point1.y + point2.y);
};

export const subtract = (point1, point2) => {
  if (typeof point2 === "number") {
    return point(point1.x - point2, point1.y - point2);
  }
  return point(point1.x - point2.x, point1.y - point2.y);
};

export const limit = (min, max, value) => {
  if (typeof value === "number") {
    return Math.min(Math.max(value, min), max);
  }
  return point(
    Math.min(Math.max(value.x, min.x), max.x),
    Math.min(Math.max(value.y, min.y), max.y)
  );
};

export const POINT_ZERO = point(0, 0);

export default point;
